import * as R from "ramda";

export function getLastItem<T>(arr: T[]): T | null {
    const v = R.last(arr);
    return R.isNil(v) ? null : v;
}
